import { TLCEvents } from "../../../../../js/lib/events/events";
import { LS2PAC_CONSTANTS } from "../../../../../js/main/constants";
import { SearchClientManager } from "../../../ls2pac/ClientManagers/SearchClientManager";
import { LS2PAC_Utils } from "../../../ls2pac/utils/Utils";

/**
 * tlc.ls2kids.ClientManager.Searching.TitlesSearchClientManager
 */
export class KidsTitlesSearchClientManager extends SearchClientManager {
	constructor(options) {
		super(options);

		this.addExtraListeners();
	}
	getSearchParams() {
		return {
			searchTerm: LS2PAC_Utils.getQualifiedSearchTerm(this.searchTermInfo.value, this.searchTermInfo.type),
			startIndex: this.currentPage * this.pageSize,
			hitsPerPage: this.pageSize,
			facetFilters: this.facetFilters,
			branchFilters: this.getBranchFilters(),
			sortCriteria: this.sortingData.sortKey,
			targetAudience: this.extraDataToPassBack.targetAudience,
			dbCodes: [],
			searchedFromKids: this.extraDataToPassBack.searchedFromKids,
			addToHistory: true
		};
	}
	addExtraListeners() {
		TLCEvents.on(LS2PAC_CONSTANTS.Events.onGetSpellingSuggestions, this.getSearchSpellingSuggestions, this);
	}
	onBeforeFireSearch(event) {
		if (!event.fromHistory) {
			this.resetPageCache(true);
		}

		super.onBeforeFireSearch(event);
	}
	getSearchCount() { }
}
